import { render } from "./ExpertSearch.vue?vue&type=template&id=f4c7fe40"
import script from "./ExpertSearch.vue?vue&type=script&lang=js"
export * from "./ExpertSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__